// extracted by mini-css-extract-plugin
module.exports = {"container":"FormPageLayout_container__1BsEu","formContainer":"FormPageLayout_formContainer__2iT8I","widthHalfPage":"FormPageLayout_widthHalfPage__2aUoB"};